/* Circ features — scroll-linked ball travelling down the vertical line.
   Progress is driven by scroll: 0 = ball at the top (first feature row),
   1 = ball at the bottom (last row). An eased "current" value trails the
   scroll target for smooth motion (no overshoot). The animated WebP plays
   continuously in every state (no static idle frame). */
(function () {
  const sections = document.querySelectorAll('[data-sst-features]');
  if (!sections.length) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Easing factor: fraction of the remaining distance the ball closes each
  // frame. Higher = snappier, lower = more trailing "flow". No overshoot.
  const EASE = 0.1;
  // Velocity-reactive swell: ball scales up while spinning fast, eases to 1
  // when it settles. GAIN maps scroll speed to swell; MAX caps it.
  const SCALE_GAIN = 0.5;
  const SCALE_MAX = 0.07;

  sections.forEach(function (section) {
    const line = section.querySelector('.sst-features__line');
    const ball = section.querySelector('[data-sst-ball]');
    if (!line || !ball) return;

    let target = 0; // scroll-derived progress (0..1)
    let current = 0; // eased-displayed progress
    let running = false;

    let anim = ball.querySelector('[data-sst-ball-anim]');
    const animSeconds = parseFloat(ball.dataset.animSeconds) || 0;

    // Restart the WebP from frame 0 by swapping in a fresh clone (served from
    // cache — no refetch). Needed because a WebP with no built-in loop count
    // otherwise plays once and freezes on its last frame.
    function restartAnim() {
      if (!anim) return;
      const clone = anim.cloneNode(true);
      anim.replaceWith(clone);
      anim = clone;
    }

    // Keep the animation looping forever, independent of scroll.
    if (animSeconds > 0) {
      setInterval(restartAnim, animSeconds * 1000);
    }

    // Recompute the scroll target (no spring — pure scroll mapping).
    // The ball tracks the viewport's vertical centre along the line: progress 0
    // parks it against the line's top cap, 1 against the bottom cap, so it
    // always travels the full track edge to edge.
    function computeTarget() {
      const scrollY = window.pageYOffset || document.documentElement.scrollTop;
      const vh = window.innerHeight || document.documentElement.clientHeight;

      const lineTopDoc = line.getBoundingClientRect().top + scrollY;
      const radius = ball.offsetHeight / 2;

      // Document positions of the ball's centre at progress 0 and 1 (its edges
      // sit on the caps, matching the CSS clamp in --ball-progress).
      const travelStart = lineTopDoc + radius;
      const travelEnd = lineTopDoc + line.offsetHeight - radius;

      const span = travelEnd - travelStart;
      if (span <= 0) return 0;

      const viewCenterDoc = scrollY + vh / 2;
      const progress = (viewCenterDoc - travelStart) / span;
      return Math.max(0, Math.min(1, progress));
    }

    // Paint the ball's vertical position from the eased progress value.
    function render(progress) {
      ball.style.setProperty('--ball-progress', progress.toFixed(4));
    }

    // Ease step: close a fraction of the gap each frame, no overshoot.
    // Loop until the ball has effectively reached the target.
    function tick() {
      const gap = target - current;
      current += gap * EASE;

      // Swell with scroll speed (remaining gap ≈ velocity), settle back to 1.
      const scale = 1 + Math.min(Math.abs(gap) * SCALE_GAIN, SCALE_MAX);
      ball.style.setProperty('--ball-scale', scale.toFixed(4));

      if (Math.abs(gap) > 0.0002) {
        render(current);
        window.requestAnimationFrame(tick);
      } else {
        current = target;
        ball.style.setProperty('--ball-scale', '1');
        render(current);
        running = false;
      }
    }

    function onScroll() {
      if (reduce) return;
      target = computeTarget();

      if (!running) {
        running = true;
        window.requestAnimationFrame(tick);
      }
    }

    // Initial paint without spring animation.
    target = computeTarget();
    current = target;
    render(current);

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  });
})();
